export default __webpack_public_path__ + "static/media/pastry-mobile.cc6be20f.png";